import React from 'react';
import { JSONTree } from 'react-json-tree';
import PropTypes from 'prop-types';

const customTheme = {
  cheme: 'black-white-blue',
  author: 'merc-custom-theme',
  base00: '#ffffff', // Background color (white)
  base07: '#000000', // Foreground color (black)
  base0B: '#000000', // String color (black)
  base0D: '#0000ff', // Keyword color (blue)
  base0C: '#000000', // Number color (black)
  base09: '#000000', // Error color (black)
  base0A: '#000000', // Warning color (black)
  base05: '#000000', // Comment color (black)
  base03: '#000000', // Prop name color (black)
  base08: '#000000', // Deleted prop value color (black)
  base0E: '#000000', // Regex color (black)
  base0F: '#000000', // Added prop value color (black)
};

const JSONViewer = ({ data, rootLabel }) => {
  const customLabelRenderer = (keyPath) => {
    const isRoot = keyPath[0] === 'root';
    if (isRoot) {
      return (
        <h3 style={{ fontWeight: 'bold' }} className="text-dark">
          {rootLabel || 'Root'}
        </h3>
      );
    }

    // For non-root nodes, you can either use the default rendering or customize further
    return <span style={{ fontSize: '1rem' }}>{keyPath[0]}</span>;
  };

  return (
    <div
      style={{
        padding: '10px 20px',
        margin: '10px 0',
        backgroundColor: customTheme.base00,
        borderRadius: '4px',
        maxHeight: '70svh',
        overflowY: 'auto',
        border: '1px solid #ccc',
      }}
    >
      <JSONTree
        data={data}
        theme={customTheme}
        labelRenderer={customLabelRenderer}
        invertTheme={false}
        shouldExpandNode={(level) => level < 2}
      />
    </div>
  );
};

JSONViewer.defaultProps = {
  rootLabel: null,
};

JSONViewer.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  rootLabel: PropTypes.string,
};

export default JSONViewer;
